import React from "react";
import styled from "styled-components";
import { Timeline_Brand_Update } from "./Timeline_Brand_Update";

const TimelineBrand = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Leaves owner registration detail to its concise title and grouped actor metadata.
const Timeline_Owner_Registered = () => {
    return null;
};

// Displays only the archive or restoration value transition.
const Timeline_Brand_Changed = (props) => {
    return (
        <Timeline_Brand_Update event={props.event} t={props.t} />
    );
};

const timelineBrandLookup = {
    OWNER_REGISTERED: Timeline_Owner_Registered,
    BRAND_ARCHIVED: Timeline_Brand_Changed
};

// Displays only meaningful Brand creation or archive detail.
export const Timeline_Brand = (props) => {
    const TimelineBrandState = timelineBrandLookup[props.event?.type] || Timeline_Brand_Changed;

    return (
        <TimelineBrand>
            <TimelineBrandState event={props.event} t={props.t} />
        </TimelineBrand>
    );
};
